import React from "react";
import { Snackbar, Alert, useTheme, IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";
import PropTypes from "prop-types";

const CustomSnackbar = ({
  open,
  onClose,
  message,
  severity = "info",
  autoHideDuration = 3000,
  anchorOrigin = { vertical: "top", horizontal: "center" },
  variant = "filled",
  icon,
  action,
  elevation = 6,
  rounded = true,
  fullWidth = true,
}) => {
  const theme = useTheme();

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    onClose(event, reason);
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      anchorOrigin={anchorOrigin}
      sx={{
        "& .MuiSnackbar-root": {
          borderRadius: rounded ? theme.shape.borderRadius : 0,
        },
      }}
    >
      <Alert
        severity={severity}
        variant={variant}
        onClose={handleClose}
        icon={icon}
        action={
          action || (
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleClose}
            >
              <Close fontSize="small" />
            </IconButton>
          )
        }
        sx={{
          width: fullWidth ? "100%" : "auto",
          borderRadius: rounded ? theme.shape.borderRadius * 2 : 0,
          boxShadow: theme.shadows[elevation],
          alignItems: "center",
          "& .MuiAlert-message": {
            py: 1,
          },
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

CustomSnackbar.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  severity: PropTypes.oneOf(["error", "warning", "info", "success"]),
  autoHideDuration: PropTypes.number,
  anchorOrigin: PropTypes.shape({
    vertical: PropTypes.oneOf(["top", "bottom"]),
    horizontal: PropTypes.oneOf(["left", "center", "right"]),
  }),
  variant: PropTypes.oneOf(["filled", "outlined", "standard"]),
  icon: PropTypes.node,
  action: PropTypes.node,
  elevation: PropTypes.number,
  rounded: PropTypes.bool,
  fullWidth: PropTypes.bool,
};

export default CustomSnackbar;
